var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from "../../utils/apiUtils";
const GET_SET_ORDER = 'api/v2/order';
const GET_SET_ORDER_CFDI = 'api/v2/orders';
const GET_HEADER_SUMMARY = 'api/orderHeaderSummary';
const GET_SET_ORDER_CUSTOMERS_APP = 'api/v2/washdayapp/orders';
export const getNotificationOptions = function (orderId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const query = generateQueryParamsStr(['storeId'], params);
            return yield this.axiosInstance.get(`${GET_SET_ORDER}/${orderId}/notifications?${query}`, {
                headers: { Authorization: `Bearer ${this.apiToken}` },
            });
        }
        catch (error) {
            throw error;
        }
    });
};
export const getList = function (params, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` },
                signal: (options === null || options === void 0 ? void 0 : options.signal) || params.signal || undefined
            };
            const queryParams = generateQueryParamsStr([
                'store',
                'storeId',
                'storeIds',
                'status',
                'name',
                'phone',
                'email',
                'fromDate',
                'toDate',
                'sequence',
                'pageNum',
                'limit',
                'sequenceSort',
                'cleanedDateTime',
                'readyDateTime',
                'collectedDateTime',
                'collectedDateTimeMode',
                'delivery',
                'activeOnly',
                'q',
                'pickupFromDate',
                'pickupToDate',
                'deliveryFromDate',
                'deliveryToDate',
                'fetchSection',
                'cfdiId',
                'customerId',
                'assignedEmployee',
                'includeAmountDueTotal',
            ], params);
            // ], { ...params, q: params.q ? encodeURIComponent(params.q) : undefined });
            return yield this.axiosInstance.get(`${GET_SET_ORDER}?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getList orders:', error);
            throw error;
        }
    });
};
export const getOrdersHeaderSummary = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'store',
                'status',
            ], params);
            return yield this.axiosInstance.get(`${GET_HEADER_SUMMARY}?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getOrdersHeaderSummary :', error);
            throw error;
        }
    });
};
export const getById = function (id, params, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` },
                signal: (options === null || options === void 0 ? void 0 : options.signal) || undefined
            };
            const queryParams = generateQueryParamsStr([
                'fetchSection',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_ORDER}/${id}?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching:', error);
            throw error;
        }
    });
};
export const getReturnOrders = function (sourceOrderId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_ORDER}/${sourceOrderId}/returns`, config);
        }
        catch (error) {
            console.error('Error fetching return orders:', error);
            throw error;
        }
    });
};
export const getCFDIOrdersByDateAndStore = function (id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_ORDER}/${id}`, config);
        }
        catch (error) {
            console.error('Error fetching:', error);
            throw error;
        }
    });
};
export const fetchOrdersForCFDI = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                "fromDate",
                "toDate",
                "storeID",
                "storeIds",
                "includeAllStores",
                "customerID"
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_ORDER_CFDI}/cfdiPreview?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching:', error);
            throw error;
        }
    });
};
export const getListCustomersApp = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'storeId',
                'status',
                'customerId',
                'fromDate',
                'toDate',
                'sequence',
                'pageNum',
                'limit',
                'sequenceSort',
                'cleanedDateTime',
                'readyDateTime',
                'collectedDateTime',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_ORDER_CUSTOMERS_APP}?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getListCustomersApp orders:', error);
            throw error;
        }
    });
};
export const getByIdCustomersApp = function (id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_ORDER_CUSTOMERS_APP}/${id}`, config);
        }
        catch (error) {
            console.error('Error fetching:', error);
            throw error;
        }
    });
};
export const getRequestedOrdersSummary = function (storeIds) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_ORDER}/requested-summary?storeIds=${storeIds}`, config);
        }
        catch (error) {
            console.error('Error fetching:', error);
            throw error;
        }
    });
};
